export default "__VITE_ASSET__BFB9dSXr__"